"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiningArea = void 0;
var TileType_1 = require("../../TileType");
var CardName_1 = require("../../CardName");
var MiningCard_1 = require("./MiningCard");
var CardRenderer_1 = require("../render/CardRenderer");
var MiningArea = (function (_super) {
    __extends(MiningArea, _super);
    function MiningArea(name, metadata) {
        if (name === void 0) { name = CardName_1.CardName.MINING_AREA; }
        if (metadata === void 0) { metadata = {
            cardNumber: '064',
            renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                b.tile(TileType_1.TileType.MINING_AREA, true).asterix().br;
                b.production(function (pb) {
                    pb.steel(1).or().titanium(1);
                }).asterix();
            }),
            description: 'Place this tile on an area with a steel or titanium placement bonus, adjacent to another of your tiles. Increase your production of that resource 1 step.',
        }; }
        return _super.call(this, name, 4, metadata) || this;
    }
    MiningArea.prototype.getAvailableSpaces = function (player) {
        return _super.prototype.getAvailableSpaces.call(this, player)
            .filter(function (space) { return player.game.board.getAdjacentSpaces(space).some(function (adjacentSpace) { return adjacentSpace.tile !== undefined && adjacentSpace.tile.tileType !== TileType_1.TileType.OCEAN && adjacentSpace.player === player; }); });
    };
    return MiningArea;
}(MiningCard_1.MiningCard));
exports.MiningArea = MiningArea;
